import { atom } from "jotai";

export const setToTranslateAtom = atom<any | null>(null);